import { App } from "./App";

export class PostMessageHandler {

    constructor(){
        window.addEventListener("message", this.handleMessage.bind(this), false);
    }


    private handleMessage(event: MessageEvent) {
        const { type } = event.data;
        if(type == "operator-get-balance"){
            App.classicCrash.classicCrash.getBalance()
        }   
    }

    private sendToOperatorPostMessage(obj: any){
        window.parent.postMessage(obj, '*');
    }


    emitGameReady(){
        this.sendToOperatorPostMessage({action: "GAME_IS_READY"})
    }

    emitSoundOn(){
        this.sendToOperatorPostMessage({action: "SOUND_ON"})
    }

    emitSoundOff(){
        this.sendToOperatorPostMessage({action: "SOUND_OFF"})
    }

    emitInsufficientFunds(){
        this.sendToOperatorPostMessage({action: "INSUFFICIENT_FUNDS"})
    }


}